import { ActionReducerMapBuilder, isAsyncThunkAction } from '@reduxjs/toolkit'

// Accept any async thunk array — callers have diverse type parameters
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyAsyncThunkType = any

interface PaginationStateType {
  pageSize?: number
  currentItem?: number
  currentPage?: number
  totalData?: number
  last?: boolean
  direction?: string
  numberOfElements?: number
  sort?: string
  totalElements?: number
  pageIndex?: number
}

interface PaginationPayloadType {
  pagination: {
    pageSize: number
    pageIndex: number
    totalPages: number
    totalElements: number
    numberOfElements: number
  }
}

interface PaginationCustomPayloadType {
  pagination: {
    direction: string
    numberOfElements: number
    pageIndex: number
    pageSize: number
    sort: string
    totalElement: number
    totalPages: number
  }
}

export const withLoadingReducer =
  (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    extraReducers: (builder: ActionReducerMapBuilder<any>) => void,
    asyncThunk: AnyAsyncThunkType[],
  ) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (builder: ActionReducerMapBuilder<any>) => {
    extraReducers(builder)

    builder.addMatcher(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      isAsyncThunkAction(...(asyncThunk as [any, ...any[]])),
      (state, action) => {
        const { requestStatus } = action.meta
        state.isLoading = requestStatus === 'pending'
      },
    )
  }

export const setPagination = (
  state: { pagination: PaginationStateType },
  action: { payload: PaginationPayloadType | null },
) => {
  if (!action.payload) return
  const {
    pagination: { pageSize, pageIndex, totalPages, totalElements, numberOfElements },
  } = action.payload

  state.pagination = {
    pageSize,
    currentItem: numberOfElements,
    currentPage: pageIndex,
    totalData: totalElements,
    last: pageIndex === totalPages,
  }
}

export const setPaginationCustom = (
  state: { pagination: PaginationStateType },
  action: { payload: PaginationCustomPayloadType },
) => {
  const {
    pagination: {
      direction,
      numberOfElements,
      pageIndex,
      pageSize,
      sort,
      totalElement,
      totalPages,
    },
  } = action.payload

  state.pagination = {
    direction,
    numberOfElements,
    pageIndex,
    pageSize,
    sort,
    totalElements: totalElement,
    currentItem: numberOfElements,
    currentPage: pageIndex,
    last: pageIndex * pageSize >= totalPages,
  }
}

export const stopLoadingHandler = (state: { isLoading: boolean }) => {
  state.isLoading = false
}
